import React, { useState } from "react";
import "./MarketMoverSection.css";

/**
 * Wrap your 3 MarketCard components with this.
 * Desktop: shows all 3 in a grid (unchanged)
 * Mobile: shows tab switcher + 1 card at a time
 *
 * Usage:
 * <MarketMoversSection
 *   gainersCard={<MarketCard ... type="gainer" title="Gainers" />}
 *   losersCard={<MarketCard ... type="loser" title="Losers" />}
 *   activeCard={<MarketCard ... type="active" title="Most Active" />}
 * />
 */
const MarketMoverSection = ({ gainersCard, losersCard, activeCard }) => {
  const [activeTab, setActiveTab] = useState("gainers");

  return (
    <>
      {/* DESKTOP: all 3 cards in grid (unchanged) */}
      <div className="mm-desktop-grid">
        {gainersCard}
        {losersCard}
        {activeCard}
      </div>

      {/* MOBILE: tab switcher + single card */}
      <div className="mm-mobile-tabs">
        <div className="mm-tab-bar">
          <button
            className={`mm-tab ${activeTab === "gainers" ? "active green" : ""}`}
            onClick={() => setActiveTab("gainers")}
          >
            Gainers
          </button>
          <button
            className={`mm-tab ${activeTab === "losers" ? "active red" : ""}`}
            onClick={() => setActiveTab("losers")}
          >
            Losers
          </button>
          <button
            className={`mm-tab ${activeTab === "active" ? "active blue" : ""}`}
            onClick={() => setActiveTab("active")}
          >
            Most Active
          </button>
        </div>

        <div className="mm-tab-content">
          {activeTab === "gainers" && gainersCard}
          {activeTab === "losers" && losersCard}
          {activeTab === "active" && activeCard}
        </div>
      </div>
    </>
  );
};

export default MarketMoverSection;
